import React, { useState } from "react";

import SettingsTutorial from "../SettingsTutorial";

import ImageProject from "../../../../assets/img/event_setsumei.webp";

import LoadingSpinner from "../../../../common/LoadingSpinner";
import Settings from "../../../../common/mypage/user-settings/Settings";
import SettingsItem from "../../../../common/mypage/user-settings/SettingsItem";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { getLinkedPages } from "../../../../redux/reducers/user";

import { PageVisibility } from "../../../../utils/PageVisibility";
import {
  useGetEvents,
  useUpdateEvent,
  useRequestEventApproval,
} from "../../../../utils/useEvent";

const EventSettingsContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);
  const linked_pages = useAppSelector(getLinkedPages);
  const queryArgs = {
    auth_token: auth_token,
    per: -1,
    id: linked_pages?.event ?? null,
  };

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = useState<number>();

  const {
    items: { events },
    isLoading,
  } = useGetEvents(queryArgs);

  const { mutateAsync, mutateLoading } = useUpdateEvent(["event", queryArgs]);
  const { requestAsync, requestLoading } = useRequestEventApproval([
    "event",
    queryArgs,
  ]);

  const tutorial = (
    <SettingsTutorial
      img_src={ImageProject}
      title="イベントとは？"
      explanation="SELeCTでは、eスポーツに関するイベント情報を掲載しています。ユーザーの皆さんが開催するような小規模のイベントの掲載も受け付けております。あなたのイベントを宣伝してみませんか？ SELeCT公式X(旧Twitter)でも宣伝させていただく場合がございます。"
    />
  );

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (id?: string) => {
    if (auth_token && id) {
      await mutateAsync({
        auth_token,
        update: {
          sonic_id: id,
          sonic_status: PageVisibility.NotPubliclyVisible,
        },
      });
    }
  };

  const handlePublish = async (id?: string) => {
    if (auth_token && id) {
      await requestAsync({ auth_token, id });
      setIsComplete(true);
    }
  };

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (isLoading || mutateLoading || requestLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <Settings
        type="イベント"
        description="イベントを作成してSELeCTに公開しましょう。 公開されることでイベントの宣伝が可能です。公式大会やコミュニティ大会、その他イベントなど気軽に作成ください。"
        link="/mypage/event-settings/create"
        tutorial={tutorial}
        currentMenu={currentMenu}
      >
        {events.length > 0
          ? events.map((el, i) => (
              <SettingsItem
                key={i}
                page_type={"イベント"}
                id={el.id}
                img_src={el?.imgs?.[0]?.thumbnail?.url}
                name={el.name}
                type={el.event_type}
                end_date={el.end_date}
                status={el.status}
                handleMenu={() =>
                  setCurrentMenu(i === currentMenu ? undefined : i)
                }
                handlePublish={handlePublish}
                handlePrivate={handlePrivate}
                edit_link={`/mypage/event-settings/${el.id}`}
                detail_link={`/event/${el.id}`}
                isMenuOpen={currentMenu === i ? true : false}
                isOwner={true}
              />
            ))
          : null}
      </Settings>
    );
  }
};

export default EventSettingsContainer;
